import { apiClient } from '../utils/apiClient';

export const authService = {
  login: async (username: string, password: string) => {
    // For demo purposes, only accept "admin/password" credentials
    if (username === 'admin' && password === 'password') {
      // Return mock successful response
      return {
        id: '1',
        username: 'admin',
        role: 'admin',
        token: 'demo-jwt-token-' + Date.now()
      };
    }
    
    // If credentials don't match, throw error
    throw new Error('Invalid credentials');
    
    // In production, this would use the actual API:
    // try {
    //   const response = await apiClient.post('/api/v1/users/login', { username, password });
    //   return response.data;
    // } catch (error) {
    //   throw new Error('Authentication failed');
    // }
  },
  
  validateToken: async (token: string) => {
    // For demo purposes, consider all tokens valid
    return true;
    
    // In production, this would validate with the backend:
    // try {
    //   const response = await apiClient.post('/api/v1/users/validate-token', { token });
    //   return response.data.valid;
    // } catch (error) {
    //   return false;
    // }
  },
  
  refreshToken: async (token: string) => {
    // For demo purposes, return a new mock token
    return {
      token: 'demo-jwt-token-refreshed-' + Date.now()
    };
    
    // In production, this would refresh with the backend:
    // try {
    //   const response = await apiClient.post('/api/v1/users/refresh-token', { token });
    //   return response.data;
    // } catch (error) {
    //   throw new Error('Token refresh failed');
    // }
  }
};
